<template>
  <div>
    <div class="storageGatewayMonitor-title">
      <div>{{ $t("alarms.storagegateway.storagegateway") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['monitor:storageGatewayMonitor:add_alert_rule']"
          @click="addOrUpdateHandle"
          >{{ $t("alarms.storagegateway.addAlertRule") }}</Button
        >
        <add-or-update-storage-gateway-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-storage-gateway-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.storagegateway.storagegatewayList')">
          <div class="storageGatewayMonitor-top">
            <storage-gateway-monitor-search></storage-gateway-monitor-search>
          </div>
          <table-storage-gateway></table-storage-gateway>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import StorageGatewayMonitorSearch from "../storage_gateway/StorageGatewayMonitorSearch";
import TableStorageGateway from "../storage_gateway/TableStorageGateway";
import AddOrUpdateStorageGatewayWarning from "../storage_gateway/AddOrUpdateStorageGatewayWarning";

export default {
  name: "StorageGatewayMonitor",
  components: {
    StorageGatewayMonitorSearch,
    TableStorageGateway,
    AddOrUpdateStorageGatewayWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.storageGatewayMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.storageGatewayMonitor-title > div:nth-child(1) {
  float: left;
}
.storageGatewayMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.storageGatewayMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/storage_gateway/StorageGatewayMonitor.vue